import { computed, ref } from 'vue'
import Modal from '../Modal/Modal.vue'

export default {
    name: 'CalculatorTable',
    components: {
        Modal
    },
    props: {
        labels: {
            type: Object,
            required: true,
        },
        headers: {
            type: Array,
            required: false,
            default: [],
        },
        rows: {
            type: Array,
            required: false,
            default: [],
        },
        tooltip: {
            type: String,
            required: false,
        },
        collapse: {
            type: Boolean,
            required: false,
            default: false,
        },
        title: {
            type: String,
            required: false,
        }
    },
    setup(props) {
        const tableContainerRef = ref(null)
        const tableCollapsed = ref(false)
        const hiddensTableItemsShown = ref(false)
        const uniqueTableId = ref(Math.random().toString(36).substr(2, 9))
        const tooltipIsOpen = ref(false)
        const tooltipTitle = ref('')
        const tooltipContent = ref('')

        const hiddenTableItems = computed(() => {
            if (props.rows.find((row) => row.hide)) {
                return true
            }

            return false
        })

        const toggleTable = function () {
            tableCollapsed.value = !tableCollapsed.value
        }

        const toggleHiddenRows = function () {
            hiddensTableItemsShown.value = !hiddensTableItemsShown.value
        }

        const showTooltip = function (title) {
            tooltipIsOpen.value = true
            tooltipTitle.value = title
            tooltipContent.value = props.tooltip
        }

        const closeTooltip = function () {
            tooltipIsOpen.value = false
        }

        const tableStylesHiddenRow = computed(() => hiddensTableItemsShown.value ? ' nyk-calculator-table--show-hidden-row' : '')
        const getTableItemStyles = (item) => item.styles ? 'nyk-table__container__table__body__row__item--' + item.styles : ''
        const getAccordionNameFromTable = () => props.rows[0]?.row[0]?.name
        const getAccordionValueFromTable = () => props.rows[0]?.row[1]?.name

        return {
            tooltipIsOpen,
            tooltipTitle,
            tooltipContent,
            tableContainerRef,
            tableCollapsed,
            hiddenTableItems,
            hiddensTableItemsShown,
            closeTooltip,
            toggleTable,
            toggleHiddenRows,
            showTooltip,
            tableStylesHiddenRow,
            getTableItemStyles,
            getAccordionNameFromTable,
            getAccordionValueFromTable,
            uniqueTableId
        }
    },
}
